module.exports = __webpack_public_path__ + "img/hero-image-white-label.7267158e.png";